module.exports = __webpack_public_path__ + "img/guide_dir_02.9132f3b1.png";